module.exports = __webpack_public_path__ + "static/appstore-button-4690d3c65b0cd63b59e03e2b85575a23.svg";